import {WebConferencesSlidesRepository} from "@api/repositories/WebConferencesSlidesRepository";
import {Store} from "vuex";
import {WebConferencesSlides} from "@api/models/WebСonferencesSlides";

export class SlidesService {
    isLoadingList = false;

    constructor(
        private readonly presentationsRepository: WebConferencesSlidesRepository,
        private readonly schemaId: string,
        private readonly objectId: string,
        private readonly store: Store<any>
    ) {
    }

    async fetchList(): Promise<WebConferencesSlides[]> {
        this.isLoadingList = true;
        try {
            return await this.presentationsRepository.list(this.schemaId, this.objectId)
        }
        catch (e) {
            this.store.dispatch("reportError", e);
            return [];
        }
        finally {
            this.isLoadingList = false;
        }
    }

    async delete(id: string): Promise<boolean> {
        try {
            await this.presentationsRepository.delete(this.schemaId, this.objectId, id);
            return true;
        }
        catch (e) {
            this.store.dispatch("reportError", e);
            return false;
        }
    }

    async get(id: string): Promise<WebConferencesSlides | null> {
        try {
            return await this.presentationsRepository.get(this.schemaId, this.objectId, id);
        }
        catch (e) {
            this.store.dispatch("reportError", e);
            return null;
        }
    }
}
